"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../Constant");

var _Anchors = require("../Text/Anchors");

function _templateObject10() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background: ", ";\n  color: ", ";\n  border: 2px solid ", ";\n  border-radius: 100px;\n  display: inline-block;\n  width: 14.5rem;\n  max-height: 3.6rem;\n  text-align: center;\n  padding: 10px 0;\n  font-size: 1.3rem;\n  font-weight: 700;\n  letter-spacing: 0.045em;\n  text-decoration: none;\n\n  /* Focus styles are on keyboard focus */\n  &:hover,\n  &[data-focus-visible-added]:focus {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n\n  /* box-shadow is used because the focus outline follows the border-radius curve and is placed outside of the link */\n  &[data-focus-visible-added]:focus {\n    box-shadow: 0 0 0 4px ", ";\n    /* Visible outline for high contrast mode */\n    outline: 2px solid transparent;\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  font-weight: 600;\n  color: ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-left: 7px;\n  vertical-align: middle;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-top: 24px;\n\n  > a:not(:last-child) {\n    margin-right: 24px;\n  }\n\n  @media print, screen and (min-width: ", "px) {\n    justify-content: space-between;\n    flex-direction: column;\n    min-height: 80px;\n\n    > a:not(:last-child) {\n      margin-right: 0;\n    }\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 1.5rem;\n  color: ", ";\n  font-weight: 400;\n  letter-spacing: 0.035em;\n  margin-top: 16px;\n\n  @media print, screen and (min-width: ", "px) {\n    margin-top: 10px;\n    max-width: 39.3rem;\n  }\n\n  @media print, screen and (min-width: ", "px) {\n    text-align: center;\n    min-height: 11.6rem;\n    max-width: 27.5rem;\n    margin: 0;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  font-family: ", ";\n  letter-spacing: -0.02em;\n  font-weight: 700;\n  margin-bottom: 16px;\n  margin-top: 0;\n\n  @media print, screen and (min-width: ", "px) {\n    text-align: center;\n    font-size: 2rem;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n\n  @media print, screen and (min-width: ", "px) {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    min-height: 230px;\n    justify-content: space-between;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  @media print, screen and (min-width: ", "px) {\n    display: flex;\n  }\n\n  @media print, screen and (min-width: ", "px) {\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  border-bottom: 1px solid ", ";\n  padding: 25px 0;\n\n  &:last-of-type {\n    border: none;\n  }\n\n  h3 {\n    margin-top: 0;\n  }\n\n  @media print, screen and (min-width: ", "px) {\n    border-bottom: none;\n    border-right: 1px solid ", ";\n    padding: 0 28px;\n    width: 380px;\n\n    &:last-of-type {\n      border: none;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-left: 0;\n  margin-right: 0;\n\n  @media print, screen and (min-width: ", "px) {\n    flex-direction: row;\n    padding: 60px 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * When we eventually refactor this component, we can simplify the CSS by using `div` elements.
 * The `Row` and `Column` components have CSS attached to them that isn't needed.
 * In the meantime, `margin-left` and `margin-right` is being reset.
 * Additionally, we should consider using responsive units for width and height.
 * `px` is used with padding the modal has limited space to grow when resized
 */
var ProductRow = _styledComponents.default.div(_templateObject(), _Constant.Width.LG);

var ProductColumn = _styledComponents.default.div(_templateObject2(), _Constant.Color.LIGHT_GREY_BORDER_2, _Constant.Width.LG, _Constant.Color.LIGHT_GREY_BORDER_2);

var ProductContainer = _styledComponents.default.div(_templateObject3(), _Constant.Width.MD, _Constant.Width.LG);

var ProductDetails = _styledComponents.default.div(_templateObject4(), _Constant.Width.LG);

var ProductHeader = _styledComponents.default.h3(_templateObject5(), _Constant.Font.SECONDARY_HEADER_FONT, _Constant.Width.LG);

var ProductDescription = _styledComponents.default.p(_templateObject6(), _Constant.Color.DARK_GREY, _Constant.Width.MD, _Constant.Width.LG);

var ProductFooter = _styledComponents.default.div(_templateObject7(), _Constant.Width.LG);

var LearnMore = _styledComponents.default.img(_templateObject8());

var LearnMoreLink = (0, _styledComponents.default)(_Anchors.SmallAnchor)(_templateObject9(), _Constant.Color.PURPLE_RAIN);

var FindRateButton = _styledComponents.default.a(_templateObject10(), function (props) {
  return props.secondary ? _Constant.Color.WHITE : _Constant.Color.PURPLE_RAIN;
}, _Constant.Color.WHITE, _Constant.Color.PURPLE_RAIN, _Constant.Color.BLACK, _Constant.Color.BLACK, _Constant.Color.WHITE, _Constant.Color.FOCUS);
/**
 * Typically, each product has a `productId`.
 * When we temporarily turn off a product, it may not have a `productId`.
 * The index is used as a fallback for the key since the order of the `ProductColumn` does not change.
 */


var ProductCard = function ProductCard(_ref) {
  var productFilter = _ref.productFilter,
      productList = _ref.productList;
  var filteredProducts = productList.filter(function (product) {
    return !productFilter.includes(product.productId);
  });
  return /*#__PURE__*/_react.default.createElement(ProductRow, null, filteredProducts.map(function (p, i) {
    return /*#__PURE__*/_react.default.createElement(ProductColumn, {
      lg: 4,
      key: p.productId || i
    }, /*#__PURE__*/_react.default.createElement(ProductContainer, null, /*#__PURE__*/_react.default.createElement(ProductDetails, null, /*#__PURE__*/_react.default.createElement(ProductHeader, null, p.productHeader), /*#__PURE__*/_react.default.createElement(ProductDescription, null, p.productDescription), /*#__PURE__*/_react.default.createElement(ProductFooter, null, p.appStartUrl && /*#__PURE__*/_react.default.createElement(FindRateButton, {
      href: p.appStartUrl
    }, p.buttonCopy ? p.buttonCopy : 'Find my rate'), !p.hideLearnMore && /*#__PURE__*/_react.default.createElement(LearnMoreLink, {
      textColor: "".concat(_Constant.Color.DARK_GREY),
      isUnderlined: false,
      noButton: !p.appStartUrl,
      href: p.learnMoreUrl
    }, "Learn more ", /*#__PURE__*/_react.default.createElement(LearnMore, {
      src: p.learnMoreImg,
      alt: ""
    }))))));
  }));
};

ProductCard.propTypes = {
  productFilter: _propTypes.default.array,
  productList: _propTypes.default.arrayOf(_propTypes.default.shape({
    prouctId: _propTypes.default.string,
    productHeader: _propTypes.default.string,
    productDescription: _propTypes.default.string,
    learnMoreUrl: _propTypes.default.string,
    learnMoreImg: _propTypes.default.string,
    appStartUrl: _propTypes.default.string,
    productImage: _propTypes.default.string,
    imgAlt: _propTypes.default.string
  })).isRequired
};
ProductCard.defaultProps = {
  productFilter: []
};
var _default = ProductCard;
exports.default = _default;